export * from './detalle/hoja-ruta-detalle.component';
export * from './vincular/hoja-ruta-vincular.component';
